module.exports = __webpack_public_path__ + "static/newtat-2-83a41afc05772db57f924bef8e35af71.jpg";